import { generateRadixPalette } from './radix-color/generateRadixPalette';
export const generateTheme = (patch, baseTheme) => {
    return {
        ...baseTheme,
        appearance: patch.appearance,
        appearanceColor: patch.appearanceColor,
        palette: {
            ...baseTheme.palette,
            ...generatePalette(patch),
        },
    };
};
export const generatePalette = (patch) => {
    const { appearance, appearanceColor, ...palette } = patch;
    const base = {
        appearance,
        background: appearanceColor,
    };
    const palettePatch = Object.entries(palette).flatMap(([key, value]) => {
        if (['background', 'text'].includes(key)) {
            const generatedPalette = generateRadixPalette({
                ...base,
                gray: value,
                accent: '#cccccc',
            });
            return [
                [key, arrayToPaletteScale(generatedPalette.grayScale)],
                [
                    key + 'A',
                    arrayToPaletteScale(generatedPalette.grayScaleAlpha),
                ],
            ];
        }
        else {
            const generatedPalette = generateRadixPalette({
                ...base,
                accent: value,
                gray: '#cccccc',
            });
            return [
                [key, arrayToPaletteScale(generatedPalette.accentScale)],
                [
                    key + 'A',
                    arrayToPaletteScale(generatedPalette.accentScaleAlpha),
                ],
            ];
        }
    });
    return Object.fromEntries(palettePatch);
};
// ['a', 'b', ...] => {1: 'a', 2: 'b', ...}
function arrayToPaletteScale(array) {
    return Object.fromEntries(array.map((color, i) => [i + 1, color]));
}
//# sourceMappingURL=generative-theme.js.map